import { inject } from '@angular/core';
import { CanActivateChildFn, Router, UrlTree } from '@angular/router';

import { AccountService } from './account.service';
import { LiteWelcomeService } from '../../shared/lite-login/lite-welcome.service';

/** LB-1893: the pages of Leanbyte Lite (first part of the URL); everything else is part of the full version. */
const LITE_PAGES = ['', 'nonode', 'accessdenied', 'node', 'dictionary', 'medialib', 'audit', 'my-work', 'my-elearning',
  'checklist', 'jumpto', 'help'];

/** LB-1893: full-version pages inside an allowed section. */
const FULL_VERSION_PAGES = ['audit/scheduler', 'audit/gfb', 'audit/audit-report'];

/**
 * LB-1893: Leanbyte Lite and Lite+ users only open the Lite pages. Any other page, also typed in as a URL (e.g.
 * /tpm/scheduler), shows the access denied page. Other users are not affected.
 */
export const liteRouteGuard: CanActivateChildFn = async (_route, state): Promise<boolean | UrlTree> => {
  const liteWelcome = inject(LiteWelcomeService);
  const router = inject(Router);
  await inject(AccountService).identity(); // a Lite user+ is only known once the account is loaded (direct URL)
  if (!liteWelcome.isLiteSession(null)) {
    return true;
  }
  const path = state.url.split(/[?#;(]/)[0].replace(/^\/+|\/+$/g, '');
  const page = path.split('/')[0];
  const fullVersion = FULL_VERSION_PAGES.some(p => path === p || path.startsWith(p + '/'));
  return LITE_PAGES.includes(page) && !fullVersion ? true : router.createUrlTree(['/accessdenied']);
};
